import { useQuery } from '@tanstack/react-query'
import { useWebhooksRequestConfig } from 'hooks/useWebhooksBaseUrl'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getNotificationEvents } from 'services/WebHooksService'

export const useNotificationEventsQuery = (enabled = true) => {
  const requestConfig = useWebhooksRequestConfig()
  return useQuery({
    queryKey: reactQueryKeys.events(),
    queryFn: () => getNotificationEvents(requestConfig),
    enabled,
  })
}
